import { Component, OnDestroy } from '@angular/core';
import { UserService } from './services/user.service';
import { DatabaseService } from './services/database.service';
import { BackendAuthService } from './services/backend-auth.service';
import { RequestorBlockStateService } from './services/requestor-block-state.service';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../environments/environment';


@Component({
    selector: 'my-app',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnDestroy {
  // user: any;
  foundUser: boolean = false;
  userInitialized = false;
  loading: boolean = true;
  private loadingTimeout: any;

  constructor(
    private _user: UserService, 
    private _db: DatabaseService, 
    private backendAuth: BackendAuthService,
    private msalService: MsalService,
    public blockState: RequestorBlockStateService
  ) { }

  async ngOnInit() {
    // Set a timeout for 15 seconds - if still loading, do a hard refresh
    this.loadingTimeout = setTimeout(() => {
      if (this.loading) {
        // console.warn('Loading timeout exceeded (15 seconds), performing hard refresh...');
        // Hard refresh - bypasses cache like Ctrl+F5
        window.location.reload();
      }
    }, 15000);

    await this.initializeUser();
  }

  ngOnDestroy() {
    // Clean up timeout if component is destroyed
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }
  }

  private async initializeUser() {
    try {
      await this.msalService.instance.initialize();
      
      await this.msalService.instance.handleRedirectPromise();
      
      const accounts = this.msalService.instance.getAllAccounts();

      // Test backend authentication
      // const auth$ = await this.backendAuth.testBackendAuth();
      // auth$.subscribe({
      //   next: (res) => {
      //     console.log('Backend auth test successful');
      //   },
      //   error: (err) => {
      //     console.error('Backend auth test failed:', err);
      //   }
      // });
      
      
      if (accounts.length === 0) {
        console.log('No accounts found, redirecting to login...');
        await this.msalService.loginRedirect({
          scopes: [
            'User.Read', 
            'User.ReadBasic.All',
            environment.msal.backendApiScope  // Request backend API access during login
          ]
        });
        return;
      }
      
      this.msalService.instance.setActiveAccount(accounts[0]);
      
      this._user.graphMeCall().subscribe({
        next: (user: any) => {
          // console.log('Graph call returned:', user);
          if (user) {
            const upnLocal = user.userPrincipalName ? user.userPrincipalName.split('@')[0] : '';
            user.gmid = upnLocal ? upnLocal.substring(0, 6).toLowerCase() : '';
            
            this._db.getAdminByGMID(user.gmid).subscribe({
              next: (admin) => {
                if (admin.admin && admin.admin.gmid.toLowerCase() === user.gmid) {
                  user.isAdmin = true;
                  user.isOwner = admin.admin.owner || false;
                } else {
                  user.isAdmin = false;
                  user.isOwner = false;
                }

                this._user.setUserObservable(user);
                this.loading = false;
                // Clear the timeout since loading completed successfully
                if (this.loadingTimeout) {
                  clearTimeout(this.loadingTimeout);
                }
              },
              error: (err) => {
                console.error('getAdminByGMID call failed:', err);
                // Still surface the user so the app isn't stuck spinning forever
                user.isAdmin = false;
                user.isOwner = false;
                this._user.setUserObservable(user);
                this.loading = false;
                if (this.loadingTimeout) {
                  clearTimeout(this.loadingTimeout);
                }
              }
            });

            this._db.getAllViewers().subscribe({
              next: (viewer) => {
                if (viewer && viewer.find((v: any) => v.gmid.toLowerCase() === user.gmid)) {
                  user.isViewer = true;
                } else {
                  user.isViewer = false;
                }
              },
              error: (err) => console.error('getAllViewers call failed:', err)
            });
          }
        },
        error: (error) => {
          console.error('Graph call failed:', error);
          this.loading = false;
          // Clear the timeout since loading completed (even with error)
          if (this.loadingTimeout) {
            clearTimeout(this.loadingTimeout);
          }
        }
      });
      
    } catch (error) {
      console.error('Error during initialization:', error);
      this.loading = false;
      // Clear the timeout since loading completed (even with error)
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout);
      }
    }
  }
    


}